<template>
  <b-container class="justify-content-center">
    <h1>{{ errorMessage }}</h1>
    <b-button v-if="serverResponse!==undefined && serverResponse.param1!==''" variant=" link" @click="forwardUser">
      {{ $t("lang.label_regenerate_Token") }}
    </b-button>
  </b-container>
</template>
<script>
import ServerResponse from "@/store/ServerResponse";
import API from "@/api";

export default {
  name: "ErrorPage",
  props: {serverResponse: ServerResponse},
  data() {
    return {
      errorMessage: "",
      errorCodes: [
        {code: undefined, message: this.$t("lang.label_undefined")},
        {code: "TOKEN_ERROR_EXPIRED", message: this.$t("lang.label_token_error_expired")},
        {code: "TOKEN_ERROR", message: this.$t("lang.label_token_error")},
        {code: "DOMAIN_EXISTS", message: this.$t("lang.label_user_email_usedBy_another_user")},
        {code: "Internal Server Error", message: this.$t("lang.label_undefined")}
      ],
      generate_new_token: false
    }
  },
  methods: {
    generateMessage(message) {
      let errorMessageElement = this.errorCodes.find((errorElement) => {
        return errorElement.code === message;
      });
      this.errorMessage = errorMessageElement != null ? errorMessageElement.message : this.$t("lang.label_undefined");
    },
    forwardUser() {
      let userEmail = this.serverResponse.param2;
      let tokenKontext = this.serverResponse.param1;
      switch (tokenKontext) {
        case "VERIFY_MAIL":
          API.resendRegistrationEmail(userEmail)
              .then(() => {
                this.$router.push({name: "email-verification", params: {email: userEmail, firstUse: false}});
              })
              .catch(() => {
                this.$router.push({name: "email-verification", params: {email: userEmail, firstUse: false}});
              });
          break;
        case "RESET_PASSWORD":
          this.$router.push({name: "forgot-password", params: {email: userEmail}});
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    if (this.serverResponse === undefined)
    {
      this.generateMessage(undefined);
    }
    else {

      this.generateMessage(this.serverResponse.message);
    }

  }
};
</script>
